import React, { useState } from "react";
import {
  Box,
  MainText,
  MainTitle,
  SteppedProgressBar,
} from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import selectLanguage from "@microdoing/shared/utils/selectLanguage";
import { useSelector } from "react-redux";
import {
  getCampaignActionGoal,
  getCampaignName,
  getTotalDoneSteps,
} from "@microdoing/shared/services/userCampaign/selectors";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import { getClientLogo } from "@microdoing/shared/services/client/selectors";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";
import FastImage from "react-native-fast-image";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import { Image } from "react-native";

const IMAGE_HEIGHT = normalize(30);

const CampaignProgress = ({}) => {
  const campaignName = useSelector(getCampaignName);
  const language = useSelector(getLanguage);
  const logo = useSelector(getClientLogo);
  const campaignActionGoal = useSelector(getCampaignActionGoal);
  const totalDone = useSelector(getTotalDoneSteps);

  const [imageWidth, setImageWidth] = useState(50);

  const handleImageLoaded = ({ nativeEvent }) => {
    if (isWeb) {
      Image.getSize(logo, (width, height) => {
        const newImageWidth = (width / height) * IMAGE_HEIGHT;

        setImageWidth(newImageWidth);
      });

      return;
    }

    const newImageWidth =
      (nativeEvent.width / nativeEvent.height) * IMAGE_HEIGHT;

    setImageWidth(newImageWidth);
  };

  return (
    <Box
      backgroundColor="neutral.white"
      borderRadius={8}
      padding="sm"
      marginBottom="sm"
    >
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="xs"
      >
        <Box maxWidth="60%">
          <MainTitle variant="l6-bold" numberOfLines={2}>
            {selectLanguage({ text: campaignName, language })}
          </MainTitle>
        </Box>
        <FastImage
          onLoad={handleImageLoaded}
          source={{ uri: logo }}
          resizeMode="contain"
          style={{
            borderRadius: 8,
            maxWidth: normalize(82),
            maxHeight: IMAGE_HEIGHT,
            width: imageWidth,
            height: IMAGE_HEIGHT,
          }}
        />
      </Box>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="xs"
      >
        <Box maxWidth="80%">
          <MainText variant="l4-medium" color="neutral.600">
            {i18n.t("campaign-progression-with-goal", {
              totalDone,
              campaignActionGoal,
            })}
          </MainText>
        </Box>
        <MainTitle variant="l6-bold" color="neutral.900">
          {((totalDone * 100) / campaignActionGoal).toFixed(0).toString() + "%"}
        </MainTitle>
      </Box>
      <SteppedProgressBar
        numberOfSteps={campaignActionGoal}
        totalDone={totalDone}
        spaceBetweenSteps={theme.spacing.xs}
      />
    </Box>
  );
};

export default CampaignProgress;
